module.exports = __webpack_public_path__ + "img/orange_talk.914aa9f6.gif";